import { render, staticRenderFns } from "./uploadIossModal.vue?vue&type=template&id=a119f96a&scoped=true"
import script from "./uploadIossModal.vue?vue&type=script&lang=js"
export * from "./uploadIossModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a119f96a",
  null
  
)

export default component.exports